import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import 'swiper/css'

const BackhoeLoaderAuthorizedDealers = () => {
  const dealerLogos = [
    {
      src: "/images/logos/rippa_authorized_dealers.webp",
      alt: "Rippa Authorized Dealers"
    },
    {
      src: "/images/logos/hengwang_authorized_dealers.webp",
      alt: "Hengwang Authorized Dealers"
    }
  ]

  return (
    <section className='bg-[#FFFFFF] sticky top-20 z-10'>
      <div className='max-w-7xl mx-auto px-6 h-[80px] sm:h-[123px] sm:px-6 lg:px-8'>
        <div className='flex items-center justify-between h-full'>
          {/* Mobile: Vertical Swiper */}
          <div className='authorized-dealer sm:hidden w-full max-w-[180px] h-[65px]'>
            <Swiper
              direction='vertical'
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              speed={800}
              loop={true}
              modules={[Autoplay]}
              className='h-full w-full'
            >
              {dealerLogos.map((logo, index) => (
                <SwiperSlide key={index} className='flex items-center justify-start'>
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className='w-full h-full max-w-[180px] max-h-[65px] object-contain'
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Desktop: Static Display */}
          <div className='authorized-dealer hidden sm:flex items-start justify-center gap-12'>
            <img
              src="/images/logos/rippa_authorized_dealers.webp"
              alt="Rippa Authorized Dealers"
              className='w-full h-full max-w-[240px] max-h-[80px] object-contain'
            />
            <img
              src="/images/logos/hengwang_authorized_dealers.webp"
              alt="Hengwang Authorized Dealers"
              className='w-full h-full max-w-[280px] max-h-[80px] object-contain'
            />
          </div>

          <div className='flex items-center justify-center px-6 sm:px-12'>
            <img
              src="/images/logos/authorized_dealer_stamp_1.png"
              alt="Authorized Dealers Stamp"
              className='flex items-start w-full max-w-[70px] sm:max-w-[95px] h-full object-contain'
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default BackhoeLoaderAuthorizedDealers